import { connect } from "react-redux";
import React, { useEffect, useRef, useState } from "react";
import "antd/dist/antd.css";
import {
  Button,
  Tooltip,
  Col,
  Form,
  Input,
  InputNumber,
  Modal,
  Row,
  Select,
  Space,
  Spin,
  Table,
  Checkbox,
  DatePicker,
  Badge,
  Layout,
  Image,
} from "antd";
import { EditFilled, InfoOutlined } from "@ant-design/icons";
import { authAxios } from "../utils";
import {
  userURL,
  userListUser,
  listprojectURL,
  createUserURL,
  resetPassUrl,
  manageUserURL,
  checkProjectURL,
  checkUserProjectURL,
} from "../constants";
import moment from "moment";
import { openNotificationWithIcon, confirm_modal } from "./Function";
import PlusOutlined from "@ant-design/icons/lib/icons/PlusOutlined";
import Cookies from "universal-cookie";
import { Link, Redirect } from "react-router-dom";
import RedoOutlined from "@ant-design/icons/lib/icons/RedoOutlined";
const cookies = new Cookies();
const logo = `${process.env.PUBLIC_URL}/logo_new/Rainscales-logo-white.png`;
const { Search } = Input;

const validateMessages = {
  required: "Vui lòng nhập ${label} !",
  types: {
    email: "${label} không đúng định dạng email!",
    number: "${label} không phải số!",
  },
  number: {
    range: "${label} must be between ${min} and ${max}",
  },
};
const fetchUserInfo = (userId) => {
  return authAxios(cookies.get("token")).get(userURL(userId));
};

const LogoImage = () => {
  return (
    <div className="logo_v2">
      <Link to={"/"}>
        <Image
          src={logo}
          preview={false}
          style={{
            objectFit: "cover",
            filter: "brightness(0) invert(1)",
            width: 180,
            height: 34,
          }}
        />
      </Link>
    </div>
  );
};

const EditUserInfo = (newDataUser, dataOld, data_check_result) => {
  let config = {
    headers: {
      Accept: "application/json",
      "Content-Type": undefined,
    },
  };
  var jsonArg1 = new Object();
  try {
    jsonArg1.username = newDataUser.tendangnhap;
    jsonArg1.msnv = dataOld["results"][0].msnv;
    jsonArg1.first_name = newDataUser.ten;
    jsonArg1.last_name = newDataUser.ho;
    jsonArg1.email = newDataUser.email;
    jsonArg1.birthday = newDataUser.birthday.format("YYYY-MM-DD");
    jsonArg1.groups = dataOld["results"][0].groups.map((item) => item);
    let lsProject_Accept = dataOld["results"][0].list_project.map(
      (item) => item.code,
    );
    jsonArg1.ls_project_code = newDataUser.webname
      .filter((item) => lsProject_Accept.includes(item))
      .map((item) => item);
    jsonArg1.ls_project_accept = newDataUser.webname.map((item) => item);
    jsonArg1.is_active = newDataUser.is_active;
    jsonArg1.is_staff = dataOld["results"][0].is_staff;
    jsonArg1.is_superuser = dataOld["results"][0].is_superuser;
    jsonArg1.data_check_result = data_check_result;
  } catch (e) {
    console.log(e);
  }
  return authAxios(cookies.get("token")).put(
    manageUserURL(dataOld["results"][0].id),
    jsonArg1,
    config,
  );
};

const CreateUserInfo = (newDataUser, selectedTagsRole) => {
  let config = {
    headers: {
      Accept: "application/json",
      "Content-Type": undefined,
    },
  };

  var jsonArg1 = new Object();
  try {
    jsonArg1.username = newDataUser.tendangnhap;
    jsonArg1.msnv = newDataUser.msnv;
    jsonArg1.first_name = newDataUser.ten;
    jsonArg1.last_name = newDataUser.ho;
    jsonArg1.email = newDataUser.email;
    jsonArg1.birthday = newDataUser.birthday.format("YYYY-MM-DD");
    jsonArg1.groups = selectedTagsRole.map((item) => item);
    jsonArg1.ls_project_code =
      newDataUser.webname != undefined
        ? newDataUser.webname.map((item) => item)
        : [];
    jsonArg1.is_active = true;
  } catch (e) {
    console.log(e);
  }

  return authAxios(cookies.get("token")).post(createUserURL, jsonArg1, config);
};

async function waitForUserInfo(userId) {
  let getUserInfo = await fetchUserInfo(userId);
  return getUserInfo;
}
async function waitForEditUserInfo(newDataUser, dataOld, data_check_result) {
  let res = await EditUserInfo(newDataUser, dataOld, data_check_result);
  return res;
}
async function waitForCreateUserInfo(newDataUser, selectedTagsRole) {
  let res = await CreateUserInfo(newDataUser, selectedTagsRole);
  return res;
}

const useResetFormOnCloseModal = ({ form, visible }) => {
  const prevVisibleRef = useRef();
  useEffect(() => {
    prevVisibleRef.current = visible;
  }, [visible]);
  const prevVisible = prevVisibleRef.current;
  useEffect(() => {
    if (!visible && prevVisible) {
      form.resetFields();
    }
  }, [visible]);
};

const ModalFormCreateUser = ({
  visible,
  onCancel,
  dataListProject,
  permission,
}) => {
  const [form] = Form.useForm();
  const [loadingModal, setLoadingModal] = useState(false);
  // const { CheckableTag } = Tag
  const [selectedTagsRole, setSelectedTagsRole] = useState([2]); // 2: thành viên | 1: đăng bài | 3: phê duyệt | 5: setting user
  const [containsBOREVENUE, setCcontainsBOREVENUE] = useState(false);

  useResetFormOnCloseModal({
    form,
    visible,
  });

  useEffect(() => {
    if (dataListProject !== undefined && dataListProject.length != 0) {
      setCcontainsBOREVENUE(
        dataListProject.some((obj) => obj.code.includes("BO-REVENUE")),
      );
    }
  }, [visible]);

  // Sử dụng async/await để xử lý Promise
  const PostCheckUserProject = async (newDataUser) => {
    let data_check_result = {
      data: { message: "" },
      ls_project_code: [],
    };
    let ls_project_code = [];
    ls_project_code =
      newDataUser.webname != undefined
        ? newDataUser.webname.map((item) => item)
        : [];
    data_check_result["ls_project_code"] = ls_project_code;
    var FormData = require("form-data");
    var data = new FormData();
    data.append("username", newDataUser.tendangnhap);
    data.append("msnv", newDataUser.msnv);
    data.append("ls_project_code", JSON.stringify(ls_project_code));
    data.append("is_active", newDataUser.is_active);
    data_check_result["data"] = await authAxios(cookies.get("token"))
      .post(checkUserProjectURL, data)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        console.log(err);
        if (err.response !== undefined) {
          if (err.response.status === 401) {
            window.location = "/login";
            return;
          }
        }
        return "Lỗi kiển tra danh mục truy cập.";
      });

    return data_check_result;
  };

  const PostCreateUser = (params) => {
    waitForCreateUserInfo(params.values, params.selectedTagsRole)
      .then((res) => {
        if (res.data.error) {
          const dataError = Object.entries(res.data.error).map(
            ([key, value]) => <p>{value}</p>,
          );
          openNotificationWithIcon("error", "Lỗi", dataError);
          setLoadingModal(false);
        } else {
          onCancelModal(true);
          setLoadingModal(false);
        }
      })
      .catch((err) => {
        if (err.data) {
          const dataError = Object.entries(err.data).map(([key, value]) => (
            <p>{value}</p>
          ));
          openNotificationWithIcon("error", "Lỗi", dataError);
          setLoadingModal(false);
        }
      });
  };

  const onFinish = async (values) => {
    if (values.msnv == 0) {
      openNotificationWithIcon("error", "Lỗi", "MSNV không hợp lệ.");
      setLoadingModal(false);
      return false;
    }
    let data_check_result = await PostCheckUserProject(values);

    const params = {
      values: values,
      selectedTagsRole: selectedTagsRole,
    };
    if (data_check_result["data"]["message"] == "Lưu") {
      PostCreateUser(params);
    } else {
      if (
        data_check_result["data"]["message"].includes("Vui lòng tạo tài khoản")
      ) {
        openNotificationWithIcon("warn", data_check_result["data"]["message"]);
      } else {
        openNotificationWithIcon("error", data_check_result["data"]["message"]);
      }
      setLoadingModal(false);
    }
  };

  const onOk = () => {
    setLoadingModal(true);
    form.submit();
  };
  const onFinishFailed = () => {
    setLoadingModal(false);
  };
  const onCancelModal = (value) => {
    setSelectedTagsRole([2]);
    onCancel(value);
  };
  const disabledDate = (current) => {
    return current && current > moment().endOf("day");
  };

  return (
    <Modal
      title="Tạo người dùng mới"
      visible={visible}
      onOk={onOk}
      onCancel={onCancelModal}
      width={800}
      forceRender
    >
      <Spin spinning={loadingModal}>
        <Form
          form={form}
          layout="vertical"
          name="userFormCreate"
          validateMessages={validateMessages}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Row>
            <Col sm={10} offset={1}>
              <Form.Item
                name="msnv"
                label="Mã số nhân viên"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <InputNumber
                  min={1}
                  style={{ width: "100%" }}
                  autoComplete="off"
                />
              </Form.Item>
              <Form.Item
                name="ho"
                label="Họ"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="ten"
                label="Tên"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col sm={10} offset={1}>
              <Form.Item
                name="tendangnhap"
                label="Tên đăng nhập"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="birthday"
                label="Ngày sinh"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <DatePicker
                  format="DD/MM/YYYY"
                  disabledDate={disabledDate}
                  placeholder="DD/MM/YYYY"
                  style={{ width: "100%" }}
                  allowClear={false}
                />
              </Form.Item>
              <Form.Item
                name="email"
                label="Email"
                rules={[
                  {
                    type: "email",
                    message: "Vui lòng nhập đúng định dạng E-mail!",
                  },
                  {
                    required: true,
                    message: "Vui lòng nhập E-mail!",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Badge.Ribbon
                color="gray"
                text={
                  <Tooltip title="Thông tin người dùng sẽ tạo đến các danh mục được chọn.">
                    <InfoOutlined />
                  </Tooltip>
                }
              >
                <Form.Item name="webname" label="Danh mục được truy cập">
                  <Select mode="multiple">
                    {dataListProject.map((item) => (
                      <Select.Option key={item.code} value={item.code}>
                        {item.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Badge.Ribbon>
            </Col>
          </Row>
          {containsBOREVENUE && (
            <>
              <Row>
                <Col sm={22}>
                  <h4 style={{ color: "#a91c1c" }}>Lưu ý: </h4>
                </Col>
              </Row>
              <Row>
                <Col sm={22}>
                  <h4 style={{ color: "#73879C" }}>
                    &nbsp;- Danh mục được truy cập:
                    <br />
                    &nbsp;&nbsp;+ Sử dụng tên đăng nhập trên để tạo tài khoản
                    trước tại web Quản lý doanh thu hoặc web Quản lý chứng từ
                    chi phí.
                    <br />
                    &nbsp;&nbsp;+ Nếu thêm danh mục, hệ thống sẽ tự động đặt lại
                    mật khẩu mặc định.
                  </h4>
                </Col>
              </Row>
            </>
          )}
        </Form>
      </Spin>
    </Modal>
  );
};

const ModalFormEditUser = ({
  visible,
  onCancel,
  dataUserEdit,
  dataListProject,
  resultAccept,
}) => {
  const [form] = Form.useForm();
  const [loadingModal, setLoadingModal] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [containsBOREVENUE, setCcontainsBOREVENUE] = useState(false);

  let lsProject_NoAccept = [];
  if (dataUserEdit.hasOwnProperty("results")) {
    lsProject_NoAccept =
      dataUserEdit["results"][0].list_project != undefined
        ? dataUserEdit["results"][0].list_project.map((item) => item.code)
        : [];
  }
  const [valueSelected, setValueSelected] = useState(
    dataListProject
      .filter((item) => !lsProject_NoAccept.includes(item.code))
      .map((item) => item.code),
  );

  useResetFormOnCloseModal({
    form,
    visible,
  });

  const PutCheckProject = async (newDataUser, dataOld) => {
    let data_check_result = {
      data: { message: "" },
      ls_project_code: [],
      ls_project_accept: [],
    };
    let ls_project_code = [];
    let ls_project_accept = [];
    let lsProject_Accept = dataOld["results"][0].list_project.map(
      (item) => item.code,
    );
    ls_project_code = newDataUser.webname
      .filter((item) => lsProject_Accept.includes(item))
      .map((item) => item);
    ls_project_accept = newDataUser.webname.map((item) => item);
    data_check_result["ls_project_code"] = ls_project_code;
    data_check_result["ls_project_accept"] = ls_project_accept;
    var FormData = require("form-data");
    var data = new FormData();
    data.append("id_user", dataOld["results"][0].id);
    data.append("username", newDataUser.tendangnhap);
    data.append("msnv", newDataUser.msnv);
    data.append("ls_project_code", JSON.stringify(ls_project_code));
    data.append("ls_project_accept", JSON.stringify(ls_project_accept));
    data.append("is_active", newDataUser.is_active);
    data_check_result["data"] = await authAxios(cookies.get("token"))
      .post(checkProjectURL, data)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        console.log(err);
        if (err.response !== undefined) {
          if (err.response.status === 401) {
            window.location = "/login";
            return;
          }
        }
        return "Lỗi kiển tra danh mục truy cập.";
      });

    return data_check_result;
  };

  const PutEditUser = (params) => {
    waitForEditUserInfo(
      params.values,
      params.dataUserEdit,
      params.data_check_result,
    )
      .then((res) => {
        console.log(res.data);

        if (res.data.error) {
          const dataError = Object.entries(res.data.error).map(
            ([key, value]) => <p>{value}</p>,
          );
          openNotificationWithIcon("error", "Lỗi", dataError);
          setLoadingModal(false);
        } else {
          if (res.data.hasOwnProperty("msg_resetpw")) {
            if (res.data.msg_resetpw != "") {
              openNotificationWithIcon("success", res.data.msg_resetpw);
            }
          }
          onCancelModal(true);
          setLoadingModal(false);
        }
      })
      .catch((err) => {
        if (err.data) {
          const dataError = Object.entries(err.data).map(([key, value]) => (
            <p>{value}</p>
          ));
          openNotificationWithIcon("error", "Lỗi", dataError);
          setLoadingModal(false);
        }
      });
  };

  const onFinish = async (values) => {
    // PutCheckProject là một hàm bất đồng bộ (asynchronous)
    let data_check_result = await PutCheckProject(values, dataUserEdit);
    const params = {
      values: values,
      dataUserEdit: dataUserEdit,
      data_check_result: data_check_result,
    };
    if (data_check_result["data"]["message"] == "Lưu") {
      PutEditUser(params);
    } else {
      if (
        data_check_result["data"]["message"].includes(
          "Xác nhận xóa truy cập web",
        )
      ) {
        confirm_modal(
          data_check_result["data"]["message"],
          PutEditUser,
          params,
        );
      } else {
        openNotificationWithIcon("error", data_check_result["data"]["message"]);
      }
      setLoadingModal(false);
    }
  };

  useEffect(() => {
    if (dataUserEdit.hasOwnProperty("results")) {
      setIsActive(dataUserEdit["results"][0].is_active);
      form.setFieldsValue({
        msnv: dataUserEdit["results"][0].msnv,
        tendangnhap: dataUserEdit["results"][0].username,
        ten: dataUserEdit["results"][0].first_name,
        ho: dataUserEdit["results"][0].last_name,
        email: dataUserEdit["results"][0].email,
        birthday:
          dataUserEdit["results"][0].birthday != null
            ? moment(dataUserEdit["results"][0].birthday)
            : dataUserEdit["results"][0].birthday,
        is_active: dataUserEdit["results"][0].is_active,
        webname: dataListProject
          .filter((item) => !lsProject_NoAccept.includes(item.code))
          .map((item) => item.code),
      });
    }
    setValueSelected(
      dataListProject
        .filter((item) => !lsProject_NoAccept.includes(item.code))
        .map((item) => item.code),
    );

    if (dataListProject !== undefined && dataListProject.length != 0) {
      setCcontainsBOREVENUE(
        dataListProject.some((obj) => obj.code.includes("BO-REVENUE")),
      );
    }
  }, [dataUserEdit]);

  const onOk = () => {
    setLoadingModal(true);
    form.submit();
  };
  const onFinishFailed = () => {
    setLoadingModal(false);
  };
  const onCancelModal = (value) => {
    onCancel(value);
  };
  const setActive = (e) => {
    setIsActive(e.target.checked);
    form.setFieldsValue({
      is_active: e.target.checked,
    });
  };
  const disabledDate = (current) => {
    return current && current > moment().endOf("day");
  };

  return (
    <Modal
      title="Chỉnh sửa thông tin người dùng"
      visible={visible}
      onOk={onOk}
      onCancel={onCancelModal}
      okText="Lưu"
      width={800}
      forceRender
    >
      <Spin spinning={loadingModal}>
        <Form
          form={form}
          layout="vertical"
          name="userFormEdit"
          validateMessages={validateMessages}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <Row>
            <Col sm={10} offset={1}>
              <Form.Item name="msnv" label="Mã số nhân viên" rules={[]}>
                <Input disabled />
              </Form.Item>

              <Form.Item
                name="ho"
                label="Họ"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="ten"
                label="Tên"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item name="is_active" label="Kích hoạt">
                <Checkbox
                  defaultChecked={
                    dataUserEdit.hasOwnProperty("results") &&
                    dataUserEdit["results"][0].is_active
                  }
                  checked={isActive}
                  onChange={(e) => setActive(e)}
                />
              </Form.Item>
            </Col>
            <Col sm={10} offset={1}>
              <Form.Item name="tendangnhap" label="Tên đăng nhập" rules={[]}>
                <Input disabled />
              </Form.Item>
              <Form.Item
                name="birthday"
                label="Ngày sinh"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <DatePicker
                  format="DD/MM/YYYY"
                  disabledDate={disabledDate}
                  placeholder="DD/MM/YYYY"
                  style={{ width: "100%" }}
                  allowClear={false}
                />
              </Form.Item>
              <Form.Item
                name="email"
                label="Email"
                rules={[
                  {
                    type: "email",
                    message: "Vui lòng nhập đúng định dạng E-mail!",
                  },
                  {
                    required: true,
                    message: "Vui lòng nhập E-mail!",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Badge.Ribbon
                color="gray"
                text={
                  <Tooltip title="Thông tin người dùng sẽ cập nhật đến các danh mục được chọn.">
                    <InfoOutlined />
                  </Tooltip>
                }
              >
                <Form.Item name="webname" label="Danh mục được truy cập">
                  <Select mode="multiple">
                    {dataListProject.map((item) =>
                      valueSelected.includes(item.code) ? (
                        <Select.Option
                          key={item.code}
                          value={item.code}
                          disabled={!resultAccept.includes(item.code)}
                        >
                          {item.name}
                        </Select.Option>
                      ) : (
                        <Select.Option key={item.code} value={item.code}>
                          {item.name}
                        </Select.Option>
                      ),
                    )}
                  </Select>
                </Form.Item>
              </Badge.Ribbon>
            </Col>
          </Row>
          {containsBOREVENUE && (
            <>
              <Row>
                <Col sm={22}>
                  <h4 style={{ color: "#a91c1c" }}>Lưu ý: </h4>
                </Col>
              </Row>
              <Row>
                <Col sm={22}>
                  <h4 style={{ color: "#73879C" }}>
                    &nbsp;- Danh mục được truy cập:
                    <br />
                    &nbsp;&nbsp;+ Sử dụng tên đăng nhập trên để tạo tài khoản
                    trước tại web Quản lý doanh thu hoặc web Quản lý chứng từ
                    chi phí.
                    <br />
                    &nbsp;&nbsp;+ Nếu thêm danh mục, hệ thống sẽ tự động đặt lại
                    mật khẩu mặc định.
                  </h4>
                </Col>
              </Row>
            </>
          )}
        </Form>
      </Spin>
    </Modal>
  );
};

class SettingsUsers extends React.Component {
  state = {
    filteredInfo: null,
    sortedInfo: null,
    data: [],
    dataListProject: [],
    total_page: "",
    pagination: { pageSize: 15 },
    visibleFormEditUserModal: false,
    visibleFormSetPermissionUserModal: false,
    idUserEdit: "",
    dataUserEdit: "",
    tagsRole: [1, 2, 3],
    selectedTagsRole: [],
    loading: true,
    resultAccept: [],
  };

  componentDidMount() {
    this.fetchListProject();
    this.fetchListUser({
      page_size: this.state.pagination.pageSize,
      page: 1,
      columnSort: "username",
      typeSort: "descend",
    });
  }

  fetchListUser = (params = {}) => {
    this.setState({ loading: true });
    authAxios(cookies.get("token"))
      .get(userListUser, { params: params })
      .then((res) => {
        this.setState({
          data: res.data.results,
          total_page: res.data.count,
          resultAccept: res.data.result_accept,
          loading: false,
        });
      })
      .catch((err) => {
        this.setState({ error: err, loading: false });
        if (err.status === 401) {
          this.props.history.push("/login");
        }
      });
  };

  fetchListProject = (params = {}) => {
    authAxios(cookies.get("token"))
      .get(listprojectURL)
      .then((res) => {
        this.setState({
          dataListProject: res.data,
        });
      })
      .catch((err) => {
        this.setState({ error: err, loading: false });
        if (err.status === 401) {
          this.props.history.push("/login");
        }
      });
  };

  handleChange = (pagination, filters, sorter, extra) => {
    this.setState({ loading: true });
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    pager.pageSize = pagination.pageSize;
    this.setState({
      pagination: pager,
    });
    this.fetchListUser({
      page_size: pagination.pageSize,
      page: pagination.current,
      columnSort: sorter.field || "id",
      typeSort: sorter.order || "descend",
      search: this.state.searchKey,
      // ...filters,
    });
  };

  SearchUserList = (value, event) => {
    let { sortKey, sortDirection, pageSize } = this.state;
    const pager = { ...this.state.pagination };
    pager.current = 1;
    pager.page = 1;
    this.setState({ searchKey: value, pagination: pager });
    this.fetchListUser({
      page_size: this.state.pagination.pageSize,
      page: 1,
      columnSort: "id",
      typeSort: "ascend",
      search: value,
    });
  };
  clearFilters = () => {
    this.setState({ filteredInfo: null });
  };
  editUserInfo = (idUser) => {
    waitForUserInfo(idUser).then((res) => {
      this.setState({
        idUserEdit: idUser,
        dataUserEdit: res.data,
        visibleFormEditUserModal: true,
      });
    });
  };
  resetPass = (idUser) => {
    authAxios(cookies.get("token"))
      .post(resetPassUrl, { user_id: idUser })
      .then((r) => {
        openNotificationWithIcon(
          "success",
          "Thành công",
          "Khôi phục mật khẩu thành công, mật khẩu mặc định là Rsvn@12345",
        );
        if ("errorMess" in r.data) {
          if (r.data.errorMess !== "") {
            console.log(r.data.errorMess);
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  showCreateUserModal = () => {
    this.setState({ visibleFormCreateUserModal: true });
  };
  hideEditUserModal = (value) => {
    this.setState({
      idUserEdit: "",
      visibleFormEditUserModal: false,
      dataUserEdit: "",
    });
    if (value === true) {
      this.fetchListUser({
        page_size: this.state.pagination.pageSize,
        page: 1,
        columnSort: "id",
        typeSort: "descend",
      });
      openNotificationWithIcon(
        "success",
        "Thành công",
        "Cập nhật thông tin người dùng.",
      );
    }
  };

  hideCreateUserModal = (value) => {
    this.setState({ visibleFormCreateUserModal: false, dataUserCreate: "" });
    if (value === true) {
      this.fetchListUser({
        page_size: this.state.pagination.pageSize,
        page: 1,
        columnSort: "id",
        typeSort: "descend",
      });
      this.setState({
        pagination: {
          current: 1,
          pageSize: this.state.pagination.pageSize,
        },
      });
      openNotificationWithIcon("success", "Thành công", "Tạo mới người dùng ");
    }
  };

  onUnPermission = (permission) => {
    if (permission) {
      return <Redirect to={"/"} />;
    }
    return "";
  };

  render() {
    let {
      loading,
      data,
      total_page,
      pagination,
      visibleFormEditUserModal,
      visibleFormCreateUserModal,
      dataListProject,
      resultAccept,
    } = this.state;
    let { permission } = this.props;
    const columns = [
      {
        title: "STT",
        dataIndex: "id",
        key: "index",
        render: (value, item, index) =>
          ((pagination.current || 1) - 1) * pagination.pageSize + index + 1,
        sorter: (a, b) => a.id - b.id,
        sortDirections: ["descend", "ascend", "descend"],
        fixed: "left",
        width: 70,
        align: "center",
      },

      {
        title: "Tên đăng nhập",
        dataIndex: "username",
        key: "username",
        sorter: (a) => a,
        fixed: "left",
      },
      {
        title: "MSNV",
        dataIndex: "msnv",
        key: "msnv",
        width: 100,
      },
      {
        title: "Họ",
        dataIndex: "last_name",
        key: "last_name",
      },
      {
        title: "Tên",
        dataIndex: "first_name",
        key: "first_name",
      },
      {
        title: "Ngày sinh",
        dataIndex: "birthday",
        key: "birthday",
        render: (text) => (text ? moment(text).format("L") : ""),
      },
      {
        title: "Email",
        dataIndex: "email",
        key: "email",
      },
      {
        title: "Thời gian tạo",
        dataIndex: "date_joined",
        key: "date_joined",
        render: (text) => (text ? moment(text).format("L") : ""),
      },
      {
        title: "Lần cuối đăng nhập",
        dataIndex: "last_login",
        key: "last_login",
        render: (text) =>
          text ? moment(text).format("L") : "Chưa từng đăng nhập",
      },
      {
        title: "Trạng thái",
        dataIndex: "is_active",
        key: "is_active",
        render: (text) => (text ? "Kích hoạt" : "Khóa"),
      },
      {
        title: "Thao tác",
        key: "operation",
        fixed: "right",
        width: "100px",
        render: (text, record) => (
          <Space size="small">
            <Tooltip
              placement="bottomRight"
              title={"Chỉnh sửa thông tin người dùng"}
            >
              <Button
                onClick={() => this.editUserInfo(record.id)}
                type={"primary"}
                tooltip={"test"}
              >
                <EditFilled />
              </Button>
            </Tooltip>
            <Tooltip placement="bottomRight" title={"Khôi phục mật khẩu"}>
              <Button
                onClick={() => this.resetPass(record.id)}
                type={"primary"}
                danger
              >
                <RedoOutlined />
              </Button>
            </Tooltip>
          </Space>
        ),
      },
    ];

    return permission && permission.view_user ? (
      <>
        <Layout className="site-layout" style={{ minHeight: "100vh" }}>
          <Layout.Header style={{ width: "100%", height: "6vh" }}>
            <div className="logo">
              <LogoImage />
            </div>
          </Layout.Header>
          <Layout.Content
            style={{ margin: "10px 16px 0", overflow: "initial" }}
          >
            <h1
              style={{
                textAlign: "center",
                color: "#ffffff",
                fontSize: 25,
                textTransform: "uppercase",
              }}
            >
              Quản lý người dùng
            </h1>
            <Row style={{ paddingLeft: 10, paddingRight: 10 }}>
              <Col sm={16} style={{ float: "left" }}>
                <Button type={"danger"} onClick={this.showCreateUserModal}>
                  <PlusOutlined /> Thêm người dùng mới
                </Button>
              </Col>
              <Col sm={8} style={{ float: "right" }}>
                <Search
                  placeholder="Nhập từ khóa tìm kiếm"
                  enterButton="Tìm kiếm"
                  size="normal"
                  onSearch={this.SearchUserList}
                />
              </Col>
            </Row>

            <Table
              // locale={locale}
              dataSource={data}
              columns={columns}
              loading={loading}
              bordered={true}
              rowKey="id"
              scroll={data.length > 0 && { x: 1500, y: 600 }}
              onChange={this.handleChange}
              pagination={{
                current: this.state.pagination.current,
                pageSize: this.state.pagination.pageSize,
                total: total_page,
                showSizeChanger: true,
                showQuickJumper: true,
                pageSizeOptions: ["10", "15", "25", "50"],
              }}
              style={{ fontSize: "25px", padding: 10 }}
              className={data.length !== 0 ? "" : "tabelEmpty"}
            />
            <ModalFormEditUser
              visible={visibleFormEditUserModal}
              onCancel={this.hideEditUserModal}
              dataUserEdit={this.state.dataUserEdit}
              dataListProject={dataListProject}
              resultAccept={resultAccept}
            />

            <ModalFormCreateUser
              visible={visibleFormCreateUserModal}
              onCancel={this.hideCreateUserModal}
              dataListProject={dataListProject}
              permission={permission}
            />
          </Layout.Content>
        </Layout>
      </>
    ) : (
      this.onUnPermission(permission)
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.token !== null,
    permission: state.user.permission,
  };
};
export default connect(mapStateToProps)(SettingsUsers);
